export default [
    "24 24",
    '<rect width="24" height="24" rx="3" fill="var(--ci-primary-color, currentColor)" />']

